export default "__VITE_ASSET__DGW5RWcD__"